export const strict = false

class documentoModals {
  constructor() {
    this.modal = {
      main: true,
      item: false,
      filter: false
    }
  }
}

class comprasXMLModals {
  constructor() {
    this.modal = {
      main: true,
      mensajeReceptor: false,
      inventario: false
    }
  }
}

class searchTable {
  constructor() {
    this.data = {
      searchString: '',
      searchedDB: false,
      searchedData: []
    }
  }
}

class tabSelected {
  constructor() {
    this.tabName = ''
    this.subTabName = ''
  }
}

export const state = {
  pageSelector: false,
  componentRootPage: 0,
  reloadList: 0,
  addItem: 0,
  deleteItem: 0,
  facturarMounted: false,
  latest: 0,

  // SHOW reportes
  showVentas: false,
  showStatsGeneral: false,
  showStatsCrm: false,
  showPagos: false,
  showCuentasCobrar: false,
  showCuentasPagar: false,
  showIngresos: false,
  showCompras: false,
  showPagosCompras: false,
  showEgresos: false,
  showBancos: false,
  showIva: false,
  showStatsGeneralCompras: false,
  showStatsProveedor: false,

  // table searches
  clienteStore: new searchTable().data,
  emailStore: new searchTable().data,
  birthdayStore: new searchTable().data,
  materiaPrimaModal_itemStore: new searchTable().data,
  reventaModal_itemStore: new searchTable().data,
  manufacturadoModal_itemStore: new searchTable().data,
  consumibleModal_itemStore: new searchTable().data,
  servicioModal_itemStore: new searchTable().data,
  inventarioStore: new searchTable().data,
  cuentasCobrarStore: new searchTable().data,
  cuentasPagarStore: new searchTable().data,
  facturaModalStore: new searchTable().data,
  notaDebitoModalStore: new searchTable().data,
  notaCreditoModalStore: new searchTable().data,
  tiqueteModalStore: new searchTable().data,
  mensajeReceptorModalStore: new searchTable().data,
  comprasModalStore: new searchTable().data,
  exportacionModalStore: new searchTable().data,
  otrosModalStore: new searchTable().data,
  temporalModalStore: new searchTable().data,
  suscripcionModalStore: new searchTable().data,
  anulacionComprasModalStore: new searchTable().data,
  proformaStore: new searchTable().data,
  linkStore: new searchTable().data,
  pagosVentasStore: new searchTable().data,
  pagosComprasStore: new searchTable().data,
  productionStore: new searchTable().data,
  orderStore: new searchTable().data,
  restaurantStore: new searchTable().data,
  zoneStore: new searchTable().data,
  tableStore: new searchTable().data,
  restaurantOrderStore: new searchTable().data,
  restaurantOrderDeletedStore: new searchTable().data,

  cajaStore: new searchTable().data,
  sesionStore: new searchTable().data,
  movimientoStore: new searchTable().data,

  autoEmailStore: new searchTable().data,

  // page modals components
  userModal: new documentoModals().modal,
  roleModal: new documentoModals().modal,

  clienteModal: new documentoModals().modal,
  categoriaModal: new documentoModals().modal,
  emailModal: new documentoModals().modal,
  birthdayModal: new documentoModals().modal,

  listaCreditoModal: new documentoModals().modal,
  listaProformaModal: new documentoModals().modal,
  materiaPrimaModal: new documentoModals().modal,
  reventaModal: new documentoModals().modal,
  manufacturadoModal: new documentoModals().modal,
  consumibleModal: new documentoModals().modal,
  servicioModal: new documentoModals().modal,

  fijosModal: new documentoModals().modal,
  variablesModal: new documentoModals().modal,
  descuentosModal: new documentoModals().modal,
  mermaModal: new documentoModals().modal,
  entradaModal: new documentoModals().modal,
  proveedoresModal: new documentoModals().modal,

  facturaModal: new documentoModals().modal,
  notaDebitoModal: new documentoModals().modal,
  notaCreditoModal: new documentoModals().modal,
  tiqueteModal: new documentoModals().modal,
  mensajeReceptorModal: new documentoModals().modal,
  comprasModal: new documentoModals().modal,
  comprasXMLModal: new comprasXMLModals().modal,
  exportacionModal: new documentoModals().modal,
  otrosModal: new documentoModals().modal,
  temporalModal: new documentoModals().modal,
  suscripcionModal: new documentoModals().modal,
  pagosModal: new documentoModals().modal, // pagina de lista de pagos
  pagosComprasModal: new documentoModals().modal, // pagina de lista de pagos
  linkModal: new documentoModals().modal, // pagina de lista de links de pagos

  gastosModal: new documentoModals().modal,
  listaCreditoComprasModal: new documentoModals().modal,

  anulacionComprasModal: new documentoModals().modal,

  productionModal: new documentoModals().modal,
  orderModal: new documentoModals().modal,
  orderEliminadosModal: new documentoModals().modal,

  restaurantModal: new documentoModals().modal,
  zoneModal: new documentoModals().modal,
  tableModal: new documentoModals().modal,
  restaurantOrderModal: new documentoModals().modal,

  categoriaItemModal: new documentoModals().modal,

  cajaModal: new documentoModals().modal,
  sesionModal: new documentoModals().modal,
  movimientoModal: new documentoModals().modal,

  reporteVentasModal: new documentoModals().modal,

  autoEmailModal: new documentoModals().modal,

  // menu
  menu: [],

  //tab active
  selectedTab: []
}

export const mutations = {
  SET_LATEST: (state, val) => (state.latest = val),
  SHOW_PAGE_SELECTOR: (state, val) => (state.pageSelector = val),
  SHOW_COMPONENT_ROOT_PAGE: state => (state.componentRootPage += 1), // aumenta su valor para provocar un watch y ejecutar el metodo volver en todas las páginas.
  RELOAD_LIST: state => (state.reloadList += 1),
  ADD_ITEM: state => (state.addItem += 1),
  DELETE_ITEM: state => (state.deleteItem += 1),

  // SHOW reportes
  SET_SHOW_REPORTE: (state, { show, val }) => (state[show] = val),

  // Modals
  SET_SHOW_MODAL: (state, { modal, show, val }) => (state[modal][show] = val),

  SET_FACTURAR_MOUNTED: state => (state.facturarMounted = true),

  SET_SEARCHEDDB: (state, { store, val }) => (state[store].searchedDB = val),
  SET_SEARCHSTRING: (state, { store, val }) => (state[store].searchString = val),
  SET_SEARCHEDDATA: (state, { store, val }) => (state[store].searchedData = val),

  SET_MENU_ACTIVE: (state, option) => {
    const element = state.menu.find(e => e.page === option.page)
    if (!element) {
      state.menu.push({ ...option, isActive: true })
    } else {
      // delete this element and re-push it if it's not the last 4
      const index = state.menu.findIndex(e => e.page === option.page)
      const last4 = state.menu.length - 4
      if (index < last4) {
        state.menu.splice(index, 1)
        state.menu.push({ ...option, isActive: true })
      }

      element.isActive = true
    }
    state.menu = state.menu.map(e => (e.page !== option.page ? { ...e, isActive: false } : e)) //.splice(-5)
  },

  SET_SELECTED_TAB: (state, { page, tab }) => {
    state.selectedTab[page] = tab
  }
}

export const actions = {
  webpush: async ({ rootGetters }, message) => {
    fetch(`${process.env.NUXT_ENV_WEB_PUSH}/push`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        clientid: await rootGetters['facturacion/emisorStore/get_Id'],
        message
      })
    })
      .then(res => res.json())
      .then(res => {
        console.log('Order Response push:', res)
      })
      .catch(() => {})
  }
}
